import React, { useState } from "react";
import styles from "../styles/getinvolved.module.css";

const GetInvolvedForm = ({ captcha }) => {
  const apiBase = process.env.REACT_APP_API_BASE_URL;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    address: "",
    message: "",
  });
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [captchaInput, setCaptchaInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProjectChange = (event) => {
    const { name, checked } = event.target;
    setSelectedProjects((prev) =>
      checked ? [...prev, name] : prev.filter((project) => project !== name)
    );
  };

  const handleSubmit = async () => {
    // Simple captcha validation
    const expected = captcha.num1 + captcha.num2;
    if (parseInt(captchaInput) !== expected) {
      setStatusMessage({ type: "error", message: "Captcha is incorrect" });
      return;
    }

    const formWithProjects = {
      ...formData,
      projects: selectedProjects.join(", "),
    };

    try {
      setIsSubmitting(true);
      setStatusMessage({ type: "", message: "" });

      const response = await fetch(`${apiBase}/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formWithProjects),
      });

      const data = await response.json();
      if (data.success) {
        setStatusMessage({
          type: "success",
          message: "Form submitted successfully!",
        });
        setFormData({ name: "", email: "", contact: "", address: "", message: "" });
        setSelectedProjects([]);
        setCaptchaInput("");
      } else {
        setStatusMessage({
          type: "error",
          message: data.message || "Failed to send form.",
        });
      }
    } catch (error) {
      setStatusMessage({ type: "error", message: "Error submitting form." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.getInvolved}>
      <div className={styles.leftformSection}>
        <div className={styles.partformGroup}>
          <label className={styles.heading}>BE THE PART OF OUR CIRCLE</label>
        </div>
        <div className={styles.formPart}>
          {["name", "email", "contact"].map((field, idx) => (
            <div className={styles.partformGroup} key={idx}>
              <label className={styles.formLabel} htmlFor={field}>
                {field.charAt(0).toUpperCase() + field.slice(1)} -
              </label>
              <input
                className={styles.input}
                value={formData[field]}
                type={field === "email" ? "email" : "text"}
                id={field}
                name={field}
                onChange={handleChange}
                required
              />
            </div>
          ))}

          <div className={styles.partformGroup}>
            <label className={styles.formLabel} htmlFor="address">
              Address -
            </label>
            <textarea
              className={styles.textarea}
              value={formData.address}
              id="address"
              name="address"
              rows="3"
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <div className={styles.partformGroup}>
            <label className={styles.formLabel} htmlFor="message">
              Message -
            </label>
            <textarea
              className={styles.textarea}
              value={formData.message}
              id="message"
              name="message"
              rows="2"
              onChange={handleChange}
              required
            ></textarea>
          </div>
        </div>
      </div>

      <div className={styles.projectSection}>
        <label className={styles.heading}>PROJECT CHOICE</label>
        <div className={styles.projectChoices}>
          <div className={styles.projectList}>
            {[
              "Health",
              "Education",
              "Rehabilitation",
              "Awareness Programs",
              "Fund Raising",
              "Management",
              "Public Relation",
            ].map((project, index) => (
              <div className={styles.listChoices} key={index}>
                <input
                  type="checkbox"
                  id={project.toLowerCase().replace(/\s/g, "")}
                  name={project}
                  className={styles.checkBox}
                  checked={selectedProjects.includes(project)}
                  onChange={handleProjectChange}
                />
                <label htmlFor={project.toLowerCase().replace(/\s/g, "")}>
                  {project}
                </label>
              </div>
            ))}
          </div>
        </div>

        {statusMessage.message && (
          <div className={styles.verticalGroup}>
            <p
              className={`${styles.statusMessage} ${
                statusMessage.type === "success"
                  ? styles.success
                  : styles.error
              }`}
            >
              {statusMessage.message}
            </p>
          </div>
        )}

        <div className={styles.verticalGroup}>
          <div className={styles.captchaGroup}>
            <p>
              {captcha.num1} + {captcha.num2} =
            </p>
          </div>
          <div>
            <input
              className={styles.captchaInput}
              type="text"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              required
            />
          </div>
          <div>
            <button
              className={styles.submitButton}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "sending..." : "submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInvolvedForm;
